import CustomFieldInfo from "./CustomFieldInfo";

class AddCustomFieldsInfoToPostEdit {
	constructor(containerID) {
		this.containerID = containerID;
		this.metasContainer = document.querySelector(`#${this.containerID}`);
	}

	addInfoToElements() {
		if ( this.metasContainer ) {
			const metas_elements = this.metasContainer.querySelectorAll('tr[id^="meta-"]');
			metas_elements && Array.from(metas_elements).map((element) => AddCustomFieldsInfoToPostEdit.addInfo(element));
		}
	}

	observeNewElements() {
		if ( this.metasContainer ) {
			const metasTable = this.metasContainer.querySelector('#list-table');

			if (metasTable) {
				const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

				if (MutationObserver) {
					new MutationObserver((mutations) => {
						mutations.map((mutation) => {
						mutation.addedNodes && Array
						.from(mutation.addedNodes)
						.filter((node) => 1 === node.nodeType && 'tr' === node.tagName.toLowerCase() && node.id.startsWith('meta-'))
				.map((element) => AddCustomFieldsInfoToPostEdit.addInfo(element))
				});
				}).observe(metasTable, {
						subtree:   true,
						childList: true
					});
				}
			}
		}
	}

	static addInfo(element) {
		const metas = new CustomFieldInfo(element);
		metas.init();
	}
}

export default AddCustomFieldsInfoToPostEdit;



// WEBPACK FOOTER //
// ./js/post-meta/AddCustomFieldsInfoToPostEdit.js